import { render, staticRenderFns } from "./TipoMandato.vue?vue&type=template&id=2f0699ad&scoped=true&"
import script from "./TipoMandato.vue?vue&type=script&lang=js&"
export * from "./TipoMandato.vue?vue&type=script&lang=js&"
import style0 from "./TipoMandato.vue?vue&type=style&index=0&id=2f0699ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0699ad",
  null
  
)

export default component.exports